/** Popup compacto do rastro (antes do Ver mais) fecha sozinho. */
export const POINT_DETAILS_INFO_WINDOW_MS = 5000;

export function pointDetailsInfoWindowHtml({
  t,
  weatherHtml,
  speed,
  timeLabel,
  relativeTime,
  showMore = false,
  subjectHtml = "",
  notesHtml = "",
} = {}) {
  const translate = t || ((text) => text);
  const speedText = speed == null || speed === "" ? "—" : speed;
  const notesClass = notesHtml ? " agri-point-details-iw--notes" : "";

  return (
    '<div class="agri-point-details-iw' +
    notesClass +
    '" title="' +
    translate("Dois cliques para ampliar") +
    '">' +
    '<div class="agri-point-details-iw__scroll">' +
    (subjectHtml || "") +
    (weatherHtml || "") +
    '<div class="agri-point-details-iw__row"><strong>' +
    translate("Velocidade") +
    ":</strong> " +
    speedText +
    "</div>" +
    '<div class="agri-point-details-iw__row"><strong>' +
    translate("Período") +
    ":</strong> " +
    (timeLabel || "—") +
    "</div>" +
    (relativeTime
      ? '<div class="agri-point-details-iw__rel">' + relativeTime + "</div>"
      : "") +
    (notesHtml || "") +
    (showMore
      ? '<div class="agri-point-details-iw__more">' +
        '<div id="obs-btn" class="agri-point-details-iw__more-btn" title="' +
        translate("Ver mais") +
        '">' +
        '<span class="agri-point-details-iw__eye">&#128065;</span>' +
        translate("Ver mais") +
        "</div></div>"
      : "") +
    "</div></div>"
  );
}
